export const Sizes = {
  topBar: '81px',
};